export const DAYS_PERIOD = 13; // This will be added/subtracted to the current date in order to accomplish 2 weeks period
